import { render } from "./ProhibitedItems.vue?vue&type=template&id=17f0a18e"
import script from "./ProhibitedItems.vue?vue&type=script&lang=js"
export * from "./ProhibitedItems.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__